import * as actionTypes from './action-types'

export const showSnackbar = ({ message, actionToDo, actionOnCancel }) => {
  const key = new Date().getTime() + Math.random()

  return {
    type: actionTypes.ENQUEUE_SNACKBAR,
    notification: { key, message, actionToDo, actionOnCancel },
  }
}

export const cancelSnackbar = () => ({
  type: actionTypes.HIDE,
})

export const showConfirmation = () => ({
  type: actionTypes.SHOW_CONFIRMATION,
  payload: true,
})

export const hideConfirmation = () => ({
  type: actionTypes.HIDE_CONFIRMATION,
})

export const closeSnackbar = key => ({
  type: actionTypes.CLOSE_SNACKBAR,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
})

export const removeSnackbar = key => ({
  type: actionTypes.REMOVE_SNACKBAR,
  key,
})
